var _defs, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.727273 0 0 .727273 -.954545 -1.45455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 37V11l17 13z",
    clipPath: "url(#B)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11l17 13 7-6.1L48 14V0H0z",
    clipPath: "url(#B)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 37l30-23 7.9 1L48 0v48H0z",
    clipPath: "url(#B)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 48L17 24l-4-3 35-10z",
    clipPath: "url(#B)",
    fill: "#4285f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.15b6cb611e2ef4ea86dc62873e5c6db5.svg";
export { ForwardRef as ReactComponent };